import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedWorkType {
    
    public readonly key = 'UnassignedWorkType';
  }

export type WorkType = Async<string[]> | UnassignedWorkType;

type MatchWorkTypeOptions<TReturn> = {
    Loading: () => TReturn;
    Loaded: (workType: string[]) => TReturn;
    Error: () => TReturn;
    Unassigned: (workType: []) => TReturn;
  };

export const isLoading = (workType: WorkType): workType is Loading<string[]> =>
    workType.key === 'Loading';

export const isLoaded = (workType: WorkType): workType is Loaded<string[]> => workType.key === 'Loaded';
export const isUnassignedWorkType = (workType: WorkType): workType is UnassignedWorkType => workType.key === 'UnassignedWorkType';

export const matchWorkType = <TReturn>(options: MatchWorkTypeOptions<TReturn>) => (
    worktype: WorkType
  ) => {
  
    switch (worktype.key) {
      case 'UnassignedWorkType':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(worktype.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };
  